import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { ClientCoreModule, CoreDownloadService } from '@thehubz/client/core';
import { timeout } from 'rxjs';
import { DownloadData, DownloadResponse, JackpotInfo } from '../model/jackpot-data.model';

const API_URL = '/api/jackpot-assets';

@Component({
  selector: 'wl-download',
  standalone: true,
  imports: [CommonModule, HttpClientModule, MatProgressSpinnerModule, ClientCoreModule],
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
})
export class DownloadComponent implements OnInit {
  errors: string[] = [];
  downloaded?: DownloadResponse;
  info?: { count: number; info?: JackpotInfo };
  prepare = false;

  private motif = '';
  private medium = '';
  private region = '';
  private length = '';
  private testParams = '';

  constructor(private activatedRoute: ActivatedRoute, private httpClient: HttpClient, private coreDownloadService: CoreDownloadService) {}

  ngOnInit(): void {
    const query = this.activatedRoute.snapshot.queryParamMap;

    if (this.errors.length === 0) {
      this.motif = query.get('motif') ?? '';
      this.medium = query.get('medium') ?? '';
      this.region = query.get('region') ?? '';
      this.length = query.get('length') ?? '';

      if (query.has('test')) {
        const tp = {
          r1: query.get('r1'),
          r2: query.get('r2'),
          dd: query.get('dd'),
        };
        this.testParams = JSON.stringify(tp);
      }

      this.httpClient
        .get<{ count: number; info: JackpotInfo }>(API_URL, {
          params: {
            ts: Date.now(),
            motif: this.motif,
            medium: this.medium,
            region: this.region,
            length: this.length,
            testParams: this.testParams,
            count: 'true',
          },
        })
        .pipe(timeout(30000))
        .subscribe((res) => {
          this.info = res;
        });
    }
  }

  prepareDownload() {
    this.prepare = true;
    this.httpClient
      .get<DownloadResponse>(`${API_URL}/download?ts=${Date.now()}`, {
        params: { ts: Date.now(), motif: this.motif, medium: this.medium, region: this.region, length: this.length, testParams: this.testParams },
      })
      .pipe(timeout(120000))
      .subscribe({
        next: (res) => {
          this.downloaded = res;
          if (res.downloads && res.downloads.length > 0) {
            // totalFiles: keys.size, downloads: resp
            let idx = 1;
            for (const download of res.downloads) {
              let name = download.name;
              if (res.name) {
                name = res.name;
                if (res.downloads.length > 1) {
                  name += `_${idx++}`;
                }
                name += '.zip';
              }
              download.name = name;
            }
          }
        },
        error: (err) => {
          console.error('Error downloading assets', err);
          this.errors.push('Download fehlgeschlagen. Bitte versuchen Sie es später erneut.');
        },
      });
  }

  // user has to click a button to download the zip file, because of browser security restrictions it must be a user action
  downloadZip(download: DownloadData) {
    this.coreDownloadService.downloadSignedUrl(download.downloadUrl, download.name);
  }
}
